import Vue from 'vue'
// Replace the global import with on-demand imports
import {
  Alert,
  Aside,
  Autocomplete,
  Avatar,
  Badge,
  Button,
  Card,
  Carousel,
  CarouselItem,
  Checkbox,
  CheckboxGroup,
  Col,
  Container,
  DatePicker,
  Dialog,
  Divider,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  Image,
  Loading,
  Link,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Message,
  MessageBox,
  Notification,
  Option,
  Pagination,
  Popover,
  Popconfirm,
  Radio,
  RadioGroup,
  Row,
  Select,
  Skeleton,
  SkeletonItem,
  Step,
  Steps,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Tooltip,
  Tree,
  Upload,
  Transfer
} from 'element-ui'
// Import Scrollbar from its specific path
import Scrollbar from 'element-ui/lib/scrollbar'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// 原子样式
import './assets/css/tailwind/index.css'
// element 样式 - import only base CSS
import 'element-ui/lib/theme-chalk/base.css'
import 'element-ui/lib/theme-chalk/display.css'
import './assets/css/element/index.scss'
// 自定义样式
import './assets/css/index.scss'
import './assets/crm-icomoon/style.scss'
// 黑夜模式
import './assets/css/theme/dark.scss'

import { initTolgee, cacheLanguageList } from './lang'
import App from './App.vue'

import router from './router'
import global from './components/common/global'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import filters from './filters/filters'
import VueCookies from 'vue-cookies'

import toastRegistry from './toast/index'
import disclaimer from './components/common/disclaimer/index.vue'
import VueDeviceDetector from './plugins/vue-device-detector'
import Plugins from './plugins/index'
import { dateFormat } from '@/utils/index'
import { subscribeGlobalEvent, subscribeLoginTimeOut, setupThirdPartLogin } from '@/lib/business'

import VueGtag from 'vue-gtag'
import { setupPWATracking } from './utils/gtaTracking'

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GA_ID }
  },
  router
)

Vue.use(VueDeviceDetector)
// 签名插件
import vueEsign from 'vue-esign'
Vue.use(vueEsign)
// 生成二维码插件
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
// 生成svgicon
import '@/icons/index'
import '@/directives/permission'
import md5 from 'js-md5'
import dayjs from 'dayjs'
import { axios, securityAxios } from './utils/axios'
import langdropdown from '@/components/langdropdown'
import viewImage from '@/components/dialog/viewImage.vue'
import maxOrMinDeposit from '@/components/common/max-or-min-deposit'
import '@/utils/devtool'
import CustomElFormItem from '@/components/form/customElFormItem.vue'
Vue.use(Plugins)
// Vue.use(oninputPolyfill)
Vue.use(VueClipboard)
Vue.use(toastRegistry)
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

// Register Element-UI components individually
Vue.use(Transfer)
Vue.use(Alert)
Vue.use(Aside)
Vue.use(Autocomplete)
Vue.use(Avatar)
Vue.use(Badge)
Vue.use(Button)
Vue.use(Card)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.use(Container)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Image)
Vue.use(Link)
Vue.use(Loading)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Popconfirm)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Row)
Vue.use(Select)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.component(Scrollbar.name, Scrollbar)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Submenu)
Vue.use(Switch)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Tooltip)
Vue.use(Tree)
Vue.use(Upload)

// Use loading directive & service
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service

// Mount element-ui's global methods to Vue.prototype
Vue.prototype.$message = Message
Vue.prototype.$msgBox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification

// Override element-ui Dialog default props
Dialog.props.closeOnClickModal.default = false

// Configure element-ui's locale
import ElementLocale from 'element-ui/lib/locale'
// ElementLocale.i18n((key, value) => i18n.t(key, value))

const Qs = require('qs')
Vue.prototype.$Qs = Qs
Vue.config.productionTip = false
Vue.prototype.$ajax = axios
Vue.prototype.$axios = securityAxios
Vue.prototype.$md5 = md5
Vue.prototype.$moment = dayjs

Vue.prototype.$global = global
Vue.prototype.$VueCookies = VueCookies

Vue.component('Disclaimer', disclaimer)
Vue.component('LangDropDown', langdropdown)
Vue.component('CrmDeposit', maxOrMinDeposit)
Vue.component('ViewImage', viewImage)
Vue.component('ElFormItem', CustomElFormItem)

setupThirdPartLogin()

window.zIndex = 999
const Bus = new Vue()
Vue.prototype.Bus = Bus
if (history.scrollRestoration) {
  history.scrollRestoration = 'manual'
}

// forward version to make sure the release can match the plugin's config.
function initSentryWithVersion(version) {
  import(/* webpackChunkName: "sentry" */ '@sentry/vue')
    .then((Sentry) => {
      Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
        // Use the version from version.json
        release: version,
        // Rest of your Sentry config
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
      })
    })
    .catch((err) => {
      console.error('Failed to load Sentry:', err)
    })
}

// Import our icons module instead of requiring all SVGs at once
import '@/icons'

// Function to hide the loading screen
function hideLoadingScreen() {
  const loadingElement = document.getElementById('app-loading')
  if (loadingElement) {
    loadingElement.classList.add('hidden')
    setTimeout(() => {
      if (loadingElement.parentNode) {
        loadingElement.parentNode.removeChild(loadingElement)
      }
    }, 300)
  }
}

window.updateDialogVisible = false
// Mount Vue app with common configuration
function mountApp() {
  const app = new Vue({
    name: 'CrmFe',
    router,
    store,
    // i18n,
    data: {
      Bus
    },
    async mounted() {
      dateFormat()
      // // 检查更新
      // await checkForUpdate()
      // Hide loading screen once Vue has mounted
      hideLoadingScreen()
      setupPWATracking(this.$gtag)
      try {
        // 获取服务器上的 version.json（每次请求都不会被缓存）

        const response = await fetch('/version.json?_t=' + Date.now())
        const serverData = await response.json()
        const serverVersion = String(serverData.version)

        // Initialize Sentry with the version now that we have it
        if (process.env.VUE_APP_ENV === 'production' && process.env.VUE_APP_SENTRY_DSN) {
          initSentryWithVersion(serverVersion)
        }

        const localVersion = localStorage.getItem('app_version')

        if (!localVersion) {
          // 第一次访问，记录当前版本
          localStorage.setItem('app_version', serverVersion)
        } else if (localVersion !== serverVersion) {
          window.updateDialogVisible = true
          // 检测到新版本
          this.$msgBox({
            message: this.$t('common.updateVersion'),
            showClose: false,
            closeOnClickModal: false,
            callback: () => {
              window.updateDialogVisible = false
              location.reload()
              localStorage.setItem('app_version', serverVersion) // 更新本地版本
            }
          })
        }
      } catch (error) {
        console.error('版本检查失败:', error)
      }
    },
    render: (h) => h(App)
  }).$mount('#app')

  // After mounting, wait for the next tick to ensure Vue has rendered the initial content
  app.$nextTick(() => {
    // Optional: Add a small delay to ensure smoother transition
    setTimeout(() => {
      // Call the global function to hide the loading screen
      if (window.hideAppLoading) {
        window.hideAppLoading()
      }
      // Dispatch the app-ready event to indicate Vue is fully loaded
      window.dispatchEvent(new Event('app-ready'))
    }, 100)
  })
}

function loadTolgeeWithFallback() {
  // 主CDN链接
  const primarySrc = 'https://cdn.jsdelivr.net/npm/@tolgee/web/dist/tolgee-web.umd.min.js'
  // 备份CDN链接（示例）
  const fallbackSrc = 'https://testingcf.jsdelivr.net/npm/@tolgee/web/dist/tolgee-web.umd.min.js'

  // 创建script标签
  const script = document.createElement('script')
  script.src = primarySrc
  script.async = true

  // 主脚本加载失败处理
  script.onerror = () => {
    // 创建备用脚本
    const fallbackScript = document.createElement('script')
    fallbackScript.src = fallbackSrc
    fallbackScript.async = true

    // 备用脚本加载失败处理
    fallbackScript.onerror = () => {
      document.dispatchEvent(new Event('tolgee-load-error'))
    }

    // 备用脚本加载成功
    fallbackScript.onload = () => {
      document.dispatchEvent(new Event('tolgee-loaded'))
    }

    document.head.appendChild(fallbackScript)
  }

  // 主脚本加载成功
  script.onload = () => {
    document.dispatchEvent(new Event('tolgee-loaded'))
  }

  document.head.appendChild(script)
}

// Ensure the default language is loaded before mounting the app
async function initApp() {
  try {
    // First get the language list from backend to determine the correct default language
    let languageList = null
    try {
      const response = await fetch('/common/language')
      const result = await response.json()
      if (result.code === 0) {
        languageList = result.data
        // Store the language list in the store for later use
        store.commit('setLanguageList', languageList)
        // Cache the language list for getLanguage() calls without parameters
        cacheLanguageList(languageList)
      }
    } catch (error) {
      console.warn('Failed to fetch language list from backend:', error)
    }

    // Initialize Tolgee with the language list
    const tolgee = await initTolgee(languageList)
    ElementLocale.i18n((key, value) => tolgee.t(key, value))
    subscribeGlobalEvent(Bus, tolgee)
    mountApp()
  } catch (error) {
    console.error('Failed to load language:', error)
    // Fall back to mounting anyway
    mountApp()
  }
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').then((registration) => {
    registration.onupdatefound = () => {
      const newWorker = registration.installing
      newWorker.onstatechange = () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New update is available, force reload
          console.log('New content is available, reloading...')
          newWorker.postMessage({ action: 'skipWaiting' })
        }
      }
    }
  })

  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    // 防止两个更新机制同时生效导致页面闪烁
    if (!window.updateDialogVisible) {
      window.location.reload()
    }
  })
}
//  动态设置PWA manifest
function setupDynamicPwa() {
  document.head.querySelectorAll('link[rel="manifest"]').forEach((link) => {
    link.remove()
  })
  const link = document.createElement('link')
  link.rel = 'manifest'
  link.href = `/system/mainfest?v=${Date.now()}`
  document.head.appendChild(link)
}
// 在Vue初始化前加载
setupDynamicPwa()
// 在Vue初始化前加载
loadTolgeeWithFallback()

// 监听加载完成事件再初始化Vue
document.addEventListener('tolgee-loaded', () => {
  // 加载成功初始化应用
  initApp()
})
// 加载失败弹出提示
document.addEventListener('tolgee-load-error', () => {
  alert('Tolgee加载失败，请检查网络连接或CDN服务。')
})

subscribeLoginTimeOut(Bus)
